import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';

import { VIEW_SIZE } from 'utils/device';
import { getUserType, trackInviteStarted } from 'utils/social-ecomm';
import env from 'utils/env';
import { track } from 'utils/segment';

import Button, { BUTTON_TYPES } from 'shared-components/Button/Button';
import SocialBannerContent from './SocialBannerContent';
import styles from './SocialBanner.module.css';

const SocialBanner = ({
  planCode,
  viewSize,
  openInviteModal,
  isInView,
  elementRef,
  displayTeamWidget,
  trackingData,
}) => {
  const userType = getUserType(planCode);
  const copy = get(COPY, userType, {});
  const { title, subtitle, cta, ctaMobile, onClick } = copy;
  const segmentExperience =
    !isInView && viewSize === VIEW_SIZE.small ? 'Floating CTA' : 'Sale Banner';

  const redirectToSubscribe = () => {
    window.location.href = `https://${env.hostname}/subscribe-today`;
  };

  const handleActivateTracking = () => {
    track('Activation Started', {
      ...trackingData,
      experience: segmentExperience,
      cta_name: 'START MEMBERSHIP',
    });
  };

  const handleInviteStartedTracking = (cta, ctaMobile) => {
    trackInviteStarted(
      trackingData,
      segmentExperience,
      !isInView && viewSize === VIEW_SIZE.small ? ctaMobile : cta
    );
  };

  const COPY = {
    member: {
      title: 'Shop with Your Friends',
      subtitle:
        'Send invites to your friends. You’ll be able to shop together and get access to exclusive products at incredible discounts!',
      cta: 'Send Invite',
      ctaMobile: 'Shop With Friends',
      onClick: () => {
        handleInviteStartedTracking(cta, ctaMobile);
        openInviteModal(segmentExperience);
      },
    },
    redeemed: {
      title: 'Enjoying Shopping with Friends?',
      subtitle:
        'Become a member and get access to all that FabFitFun has to offer!',
      cta: 'Start Membership',
      ctaMobile: 'Start Membership',
      onClick: () => {
        handleActivateTracking();
        redirectToSubscribe();
      },
    },
  };

  return (
    <>
      <div className={styles.ref} ref={elementRef}>
        <SocialBannerContent
          className={styles[userType]}
          title={title}
          subtitle={subtitle}
          cta={cta}
          onClick={onClick}
        />
      </div>
      {!isInView && viewSize === VIEW_SIZE.small && (
        <Button
          buttonType={BUTTON_TYPES.PRIMARY}
          onClick={onClick}
          className={classNames(styles.sticky, styles.stickyButton, {
            [styles.widgetShowing]: displayTeamWidget,
          })}
        >
          {ctaMobile}
        </Button>
      )}
      {!isInView && viewSize !== VIEW_SIZE.small && (
        <SocialBannerContent
          className={classNames(styles.sticky, styles[userType])}
          title={title}
          subtitle={subtitle}
          cta={cta}
          onClick={onClick}
        />
      )}
    </>
  );
};

SocialBanner.propTypes = {
  planCode: PropTypes.string.isRequired,
  viewSize: PropTypes.string.isRequired,
  openInviteModal: PropTypes.func.isRequired,
  isInView: PropTypes.bool.isRequired,
  elementRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  displayTeamWidget: PropTypes.bool.isRequired,
  trackingData: PropTypes.shape({}).isRequired,
};

export default SocialBanner;
